import { useLingui } from '@lingui/react';
import { formatMoneyFixed } from '@wkda/funnel-utils';
import { CheveronRightIcon } from '@wkda/icons';
import { Button } from '@wkda/styleguide';
import cx from 'classnames';
import { useCallback, useEffect } from 'react';
import { useGetDateInfoByTimeZone } from '../../hooks/useBannerReturnCustomer';
import { useCarleadConfiguration } from '../../hooks/useCarleadCreationConfiguration';
import { useCarleadDataLayer } from '../../hooks/useCarleadDataLayer';
import { useTrackCustomerBanner } from '@wkda/funnel-components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BannerContentAppointmentReminder(_ref) {
  let {
    offerPrice,
    hideCarDetails,
    manufacturer,
    isDoi,
    startDate,
    cityBranch,
    confirmBookingUrl,
    bookingUrl
  } = _ref;
  const {
    i18n: _i18n
  } = useLingui();
  const dataLayer = useCarleadDataLayer();
  const {
    locale
  } = useCarleadConfiguration();
  const formattedPriceWithCurrency = formatMoneyFixed(locale, offerPrice !== null && offerPrice !== void 0 ? offerPrice : 0);
  const {
    weekday,
    date,
    time
  } = useGetDateInfoByTimeZone(startDate !== null && startDate !== void 0 ? startDate : '');
  const {
    trackShownEvent,
    trackCTAClickEvent,
    getCJTrackingButtonNameByAttr
  } = useTrackCustomerBanner();
  const titleShort = offerPrice ? _i18n._('carleadCreation.appointmentReminderRCB.titlePriceShort', {
    manufacturer
  }) : _i18n._('carleadCreation.appointmentReminderRCB.titleNoPriceShort', {
    manufacturer
  });
  const titleFull = offerPrice ? _i18n._('carleadCreation.appointmentReminderRCB.titlePriceFull', {
    manufacturer
  }) : _i18n._('carleadCreation.appointmentReminderRCB.titleNoPriceFull', {
    manufacturer
  });
  const handleButtonClick = useCallback(e => {
    const ctaName = getCJTrackingButtonNameByAttr(e.currentTarget);
    if (ctaName) {
      trackCTAClickEvent('appointment-reminder', ctaName);
    }
  }, [getCJTrackingButtonNameByAttr, trackCTAClickEvent]);
  useEffect(() => {
    dataLayer.pushCustomerBannerOpen('appointment-remainder');
    // remainder or reminder?
    trackShownEvent('appointment-reminder');
  }, [dataLayer, trackShownEvent]);
  return /*#__PURE__*/_jsx("div", {
    className: "container appointment-reminder-rcb",
    children: /*#__PURE__*/_jsxs("div", {
      className: "row text-center",
      children: [/*#__PURE__*/_jsxs("div", {
        className: cx('col-sm-12 col-md-3 appointment-reminder-rcb__col-1', {
          'd-none': hideCarDetails
        }),
        children: [/*#__PURE__*/_jsxs("div", {
          className: "appointment-reminder-rcb__title",
          children: [/*#__PURE__*/_jsx("span", {
            className: "d-none d-md-block",
            children: titleFull
          }), /*#__PURE__*/_jsx("span", {
            className: "d-md-none",
            children: titleShort
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: cx('banner-return-customer__price', {
            'banner-return-customer__pixelated-price appointment-reminder-rcb__pixelated-price': isDoi
          }),
          children: !isDoi || !offerPrice ? formattedPriceWithCurrency : ''
        }), /*#__PURE__*/_jsx("hr", {
          className: "d-md-none"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "col-sm-12 col-md-6 appointment-reminder-rcb__col-2",
        children: [/*#__PURE__*/_jsx("div", {
          className: "appointment-reminder-rcb__title",
          children: _i18n._('carleadCreation.appointmentReminderRCB.titleAppointment')
        }), /*#__PURE__*/_jsxs("ul", {
          className: "appointment-reminder-rcb__list-appointment",
          children: [/*#__PURE__*/_jsx("li", {
            className: "appointment-reminder-rcb__list-appointment-item appointment-reminder-rcb__list-appointment-item--date",
            children: /*#__PURE__*/_jsxs("span", {
              className: "appointment-reminder-rcb__list-appointment-item-text",
              children: [weekday, " ", /*#__PURE__*/_jsx("br", {}), " ", date]
            })
          }), /*#__PURE__*/_jsx("li", {
            className: "appointment-reminder-rcb__list-appointment-item appointment-reminder-rcb__list-appointment-item--time",
            children: /*#__PURE__*/_jsx("span", {
              className: "appointment-reminder-rcb__list-appointment-item-text",
              children: time
            })
          }), /*#__PURE__*/_jsx("li", {
            className: "appointment-reminder-rcb__list-appointment-item appointment-reminder-rcb__list-appointment-item--location d-none d-sm-inline-block",
            children: /*#__PURE__*/_jsx("span", {
              className: "appointment-reminder-rcb__list-appointment-item-text appointment-reminder-rcb__list-appointment-item--last-text",
              children: cityBranch
            })
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "col-sm-12 col-md-3 appointment-reminder-rcb__col-3",
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Button, {
            "data-cj-tracking-button-name": "confirm-booking-button",
            className: "appointment-reminder-rcb__button",
            component: "a",
            variant: "primary",
            size: "md",
            href: confirmBookingUrl,
            onClick: handleButtonClick,
            children: /*#__PURE__*/_jsxs("div", {
              className: "d-flex justify-content-center align-items-center",
              children: [_i18n._('carleadCreation.appointmentReminderRCB.ctaBookingConfirmed'), /*#__PURE__*/_jsx(CheveronRightIcon, {
                className: "ml-2"
              })]
            })
          }), /*#__PURE__*/_jsx(Button, {
            "data-cj-tracking-button-name": "view-booking-button",
            component: "a",
            className: "",
            variant: "primary",
            size: "md",
            href: bookingUrl,
            onClick: handleButtonClick,
            children: /*#__PURE__*/_jsxs("div", {
              className: "d-flex justify-content-center align-items-center",
              children: [_i18n._('carleadCreation.appointmentReminderRCB.ctaBooking'), /*#__PURE__*/_jsx(CheveronRightIcon, {
                className: "ml-2"
              })]
            })
          })]
        })
      })]
    })
  });
}